
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forum/thread/[...threadOldRoute]",
      function () {
        return require("private-next-pages/forum/thread/[...threadOldRoute].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forum/thread/[...threadOldRoute]"])
      });
    }
  